import { useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { RichTextEditor } from 'core-components/library/richTextEditor'

import tr from './translations'

import styles from './EditCommentDialogContent.module.scss'

interface IProps {
  currentEditComment: string
  onApply: (value: string) => Promise<void>
  onCancel: () => void
}

export const EditCommentDialogContent = ({ currentEditComment, onApply, onCancel }: IProps) => {
  const [value, setValue] = useState<string>(currentEditComment || '')

  return (
    <div>
      <RichTextEditor
        placeholder={tr.commentPlaceholder}
        value={value}
        onChange={(val: string) => setValue(val)}
      />
      <footer className={styles.footer}>
        <Button
          className={styles.button}
          variant={'outlined'}
          onClick={() => {
            onApply(value)
          }}
        >
          <Translation text={tr.apply} />
        </Button>
        <Button color={'white'} className={styles.button} onClick={onCancel}>
          <Translation text={tr.cancel} />
        </Button>
      </footer>
    </div>
  )
}
